(function(){
  function addWhatsApp(){
    if(document.querySelector('.mt-wa'))return;
    var a=document.createElement('a');
    a.className='mt-wa';
    a.href='https://wa.me/38345666459?text='+encodeURIComponent('Përshëndetje, kam një pyetje.');
    a.target='_blank';
    a.rel='noopener';
    a.setAttribute('aria-label','Na shkruani në WhatsApp');
    a.innerHTML=`<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M21 11.5a8.4 8.4 0 0 1-12.4 7.4L3 20.5l1.7-5.4A8.4 8.4 0 1 1 21 11.5z'/><path d='M9.2 8.8c0 3 2.9 5.9 5.9 5.9'/></svg><span>WhatsApp</span>`;
    document.body.appendChild(a);
  }
  if(document.readyState!=='loading')addWhatsApp();
  else document.addEventListener('DOMContentLoaded',addWhatsApp);
})();
/* Menu: te shkruara hap koleksionin, shigjeta hap nenmenyn */
(function(){
  var M={
    "Kamera Sigurie":"/collections/kamera-siguri",
    "Kujdesi Personal":"/collections/kujdesi-personal",
    "Gaming":"/collections/gaming",
    "TV, Audio & Kufje":"/collections/tv-audio-kufje",
    "Printera & Skaner":"/collections/printera-skaner",
    "Aksesorë për Telefona":"/collections/aksesore-per-telefona",
    "Orë Smart":"/collections/smart-watch",
    "Trotineta Elektrike":"/collections/trotineta-elektrike",
    "Paisje Shtëpiake":"/collections/paisje-shtepiake"
  };
  document.addEventListener('click',function(e){
    var s=e.target.closest('summary.header__menu-item, summary.menu-drawer__menu-item');
    if(!s)return;
    if(e.target.closest('svg,.icon-caret,.svg-wrapper'))return;
    var t=(s.textContent||'').replace(/\s+/g,' ').trim();
    var u=M[t];
    if(!u)return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href=u;
  },true);
})();